import { t } from 'i18next';
import { RedirectPage } from '../../../components/redirect-page';
import { withPageProviders } from '../../../context/page-context';

export const FeaturesRedirectPage = withPageProviders(FeaturesRedirectContent);

function FeaturesRedirectContent() {
  return (
    <RedirectPage
      path="/features"
      title={t('features:explore.pages.features_redirect_page.title')}
      subtitle={t('features:explore.pages.features_redirect_page.description')}
      action={t('features:explore.pages.features_redirect_page.action')}
      imageType="themes"
    />
  );
}
